const SearchInput = ({ onChange, value, className }) => {
  return (
    <div className={`col-12 col-lg-3 mt-2 ${className}`}>
      <div className="input-group input-search">
        <input
          {...value}
          onChange={({ target }) => onChange(target.value)}
          type="text"
          className="form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto"
          placeholder="Buscar"
        />
        <span className="input-group-text bg-white border-0">
          <i className="bi bi-search text-cl-auroMetal"></i>
        </span>
      </div>
    </div>
  );
};

export default SearchInput;
